export default {
  masterclassType: {
    VIGNIFICATION: 'vignification',
    PAYS: 'pays',
    VIGNE: 'vigne',
    DEGUSTATEUR: 'degustateur'
  }
}
